<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		setDoc,
		getDoc,
		updateDoc,
		// collection,
		// addDoc,
		// arrayUnion,
		// onSnapshot,
		// deleteField,
		// serverTimestamp,
		// increment,
		// query,
		// limit,
		// orderBy,
	} from "firebase/firestore";

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));

	let setup = "base";

	let openSet = {
		gid: "",
		rid: "",
	};

	let gameSet = {
		gid: "",
		max_team_size: 5,
		name: "",
		period: {
			from: new Date().toISOString().split("T")[0],
			to: new Date().toISOString().split("T")[0],
		},
		start: {
			link: "",
			title: "",
		},
		purchaseLink: "",
	};

	let riddleSet = {
		gid: "",
		rid: "",
		header: "default",
		main: "",
		aside: "default",
		footer: "default",
		customStyling: "",
		rd_content: {
			address: "",
			answers: [],
			hints: [],
			isBonus: false,
			type: "multiple",
			// if reorder
			order_id_list: [],
			order_list: [],
			order_size: {
				rows: 2,
				cols: 2,
			},
			order_type: "disabled",
			// if panel
			panel_id_list: [],
			panel_list: [],
			panel_thumbnail_list: [],
			panel_size: {
				rows: 2,
				cols: 2,
			},
			panel_type: "disabled",
		},
	};

	let rem;

	let complexAnswerTemp = [];

	const hint = {
		content: "",
		guide: "",
		time: 1,
	};

	let types = {
		names: [
			"Single answer",
			"Single answer with alternatives",
			"List multiple",
			"List multiple with alternatives",
			"Drag&Drop Reorder",
			"Drag&Drop Reorder, but show input",
			"Button order (thumbnails)",
			"Button order (hidden)",
			"Button to input",
		],
		values: [
			"single",
			"multiple",
			"mc",
			"mc-multiple",
			"dnd-reorder",
			"dnd-reorder-show-input",
			"btn-order",
			"btn-order-hidden",
			"btn-to-input",
		],
	};

	async function saveGameSet() {
		let data = gameSet;

		let gameSetObject = {
			gid: data.gid,
			max_team_size: data.max_team_size,
			name: data.name,
			period: {
				from: new Date(data.period.from),
				to: new Date(data.period.to),
			},
			start: data.start,
			purchaseLink: data.purchaseLink,
		};
		const gameSetRef = doc(db, "games", data.gid);

		const checkSnap = await getDoc(gameSetRef);

		if (checkSnap.exists()) {
			console.log("Game exists!");
			if (confirm("Are you sure you want to update the game?")) {
				console.log("Updating existing game...");
				await updateDoc(gameSetRef, { ...gameSetObject }, { merge: true }).then(
					() => {
						console.log("DONE");
						alert("game saved");
					},
				);
			} else {
				console.log("Nothing changed!");
				alert("No changes were made.");
			}
		} else {
			if (
				confirm("A game with this GID doesn't exist. Do you want to create it?")
			) {
				await setDoc(gameSetRef, { ...gameSetObject }, { merge: true }).then(
					() => {
						console.log("DONE");
						alert("game saved");
					},
				);
			} else {
				console.log("Nothing changed!");
				alert("No changes were made.");
			}
		}
	}

	async function saveRiddleSet() {
		let data = riddleSet;
		let riddleSetObject = {
			header: data.header,
			main: data.main,
			aside: data.aside,
			footer: data.footer,
			customStyling: data.customStyling,
			rd_content: {
				address: data.rd_content.address,
				answers: data.rd_content.answers,
				hints: data.rd_content.hints,
				isBonus: data.rd_content.isBonus,
				type: data.rd_content.type,

				// if reorder
				...((riddleSet.rd_content.type == "dnd-reorder" ||
					riddleSet.rd_content.type == "dnd-reorder-show-input") && {
					order_id_list: data.rd_content.order_id_list,
					order_list: data.rd_content.order_list,
					order_size: data.rd_content.order_size,
					order_type: data.rd_content.order_type,
				}),

				// if panel
				...((riddleSet.rd_content.type == "btn-order" ||
					riddleSet.rd_content.type == "btn-order-hidden" ||
					riddleSet.rd_content.type == "btn-to-input") && {
					panel_id_list: data.rd_content.panel_id_list,
					panel_list: data.rd_content.panel_list,
					panel_thumbnail_list: data.rd_content.panel_thumbnail_list,
					panel_size: data.rd_content.panel_size,
					panel_type: data.rd_content.panel_type,
				}),
			},
		};
		const riddleSetRef = doc(db, "games", data.gid, "gamedata", data.rid);

		const checkSnap = await getDoc(riddleSetRef);

		if (checkSnap.exists()) {
			console.log("Riddle exists!");
			if (confirm("Are you sure you want to update the riddle?")) {
				console.log("Updating existing riddle...");
				await updateDoc(
					riddleSetRef,
					{ ...riddleSetObject },
					{ merge: true },
				).then(() => {
					console.log("DONE");
					alert("riddle saved");
				});
			} else {
				console.log("Nothing changed!");
				alert("No changes were made.");
			}
		} else {
			if (
				confirm(
					"A riddle with this RID doesn't exist. Do you want to create it?",
				)
			) {
				await setDoc(
					riddleSetRef,
					{ ...riddleSetObject },
					{ merge: true },
				).then(() => {
					console.log("DONE");
					alert("riddle saved");
				});
			} else {
				console.log("Nothing changed!");
				alert("No changes were made.");
			}
		}
	}

	async function handleOpenGame() {
		const openGameRef = doc(db, "games", openSet.gid);

		const checkSnap = await getDoc(openGameRef);

		if (checkSnap.exists()) {
			console.log("Game exists!");
			console.log("Loading game...");
			console.log(checkSnap.data());
			console.log(gameSet);
			let data = checkSnap.data();

			gameSet = {
				gid: data.gid,
				max_team_size: data.max_team_size,
				name: data.name,
				period: {
					from: data.period.from.toDate().toISOString().split("T")[0],
					to: data.period.to.toDate().toISOString().split("T")[0],
				},
				start: {
					link: data.start.link,
					title: data.start.title,
				},
				purchaseLink: data.purchaseLink,
			};

			console.log(gameSet);
			setup = "game";
		} else {
			console.log("A game with this GID doesn't exist!");
		}
	}

	async function handleOpenRiddle() {
		const openRiddleRef = doc(
			db,
			"games",
			openSet.gid,
			"gamedata",
			openSet.rid,
		);

		const checkSnap = await getDoc(openRiddleRef);

		if (checkSnap.exists()) {
			console.log("Riddle exists!");
			console.log("Loading riddle...");
			console.log(checkSnap.data());
			console.log(riddleSet);
			let data = checkSnap.data();

			let tempAnswers = [];

			data.rd_content.answers.forEach((element) => {
				if (typeof element === "object") {
					let s = JSON.stringify(element);
					console.log(s);
					tempAnswers.push(s);
				} else {
					tempAnswers.push(element);
					console.log(element);
				}
			});

			riddleSet = {
				gid: openSet.gid,
				rid: openSet.rid,
				header: data.header,
				main: data.main,
				aside: data.aside,
				footer: data.footer,
				customStyling: data.customStyling,
				rd_content: {
					address: data.rd_content.address,
					answers: tempAnswers,
					hints: data.rd_content.hints,
					isBonus: data.rd_content.isBonus,
					type: data.rd_content.type,
					// if reorder

					...((data.rd_content.type == "dnd-reorder" ||
						data.rd_content.type == "dnd-reorder-show-input") && {
						order_id_list: data.rd_content.order_id_list,
						order_list: data.rd_content.order_list,
						order_size: data.rd_content.order_size,
						order_type: data.rd_content.order_type,
					}),

					// if panel
					...((data.rd_content.type == "btn-order" ||
						data.rd_content.type == "btn-order-hidden" ||
						data.rd_content.type == "btn-to-input") && {
						panel_id_list: data.rd_content.panel_id_list,
						panel_list: data.rd_content.panel_list,
						panel_thumbnail_list: data.rd_content.panel_thumbnail_list,
						panel_size: data.rd_content.panel_size,
						panel_type: data.rd_content.panel_type,
					}),
				},
			};

			complexAnswerTemp = tempAnswers;

			console.log(riddleSet);
			setup = "riddle";
		} else {
			console.log("A game with this GID doesn't exist!");
		}
	}
</script>

<!--  -->
<!--  -->
<!--  -->
<p class="mt-6 uppercase">VG Panel</p>
<h1>Game Creator</h1>

{#if setup == "base"}
	<button on:click={() => (setup = "game")}
		><i class="fa-solid fa-gamepad" data-position="left" />Setup Game</button
	>
	<button on:click={() => (setup = "riddle")}
		><i class="fa-solid fa-puzzle-piece" data-position="left" />Setup Riddle</button
	>
	<button on:click={() => (setup = "open-game")} class="secondary">
		<i class="fa-solid fa-folder-open" data-position="left" />Open Game</button
	>
	<button on:click={() => (setup = "open-riddle")} class="secondary"
		><i class="fa-solid fa-puzzle-piece" data-position="left" />Open Riddle</button
	>
{:else if setup == "game"}
	<div class="flex flex-wrap">
		<div class="grid grow sm:grow-0">
			<label for="gid">GID:</label>
			<input
				type="text"
				name="gid"
				maxlength="10"
				id="gid"
				bind:value={gameSet.gid}
				placeholder="Game ID"
				title="Game ID"
			/>
		</div>

		<div class="grid grow min-w-[50vw]">
			<label for="game_name">Game name:</label>
			<input
				type="text"
				name="game_name"
				id="game_name"
				bind:value={gameSet.name}
				placeholder="Game name"
				title="Game name"
			/>
		</div>
	</div>

	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="period_from">Period from:</label>
			<input
				type="date"
				name="period_from"
				id="period_from"
				bind:value={gameSet.period.from}
				placeholder="Inactive before"
				title="Inactive before"
			/>
		</div>

		<div class="grid grow">
			<label for="period_to">Period to:</label>
			<input
				type="date"
				name="period_to"
				id="period_to"
				bind:value={gameSet.period.to}
				placeholder="Inactive after"
				title="Inactive after"
			/>
		</div>
	</div>

	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="max_team_size">Max Team Size:</label>
			<input
				type="number"
				name="max_team_size"
				min="1"
				id="max_team_size"
				bind:value={gameSet.max_team_size}
				placeholder="Maximum team size"
				title="Maximum team size"
			/>
		</div>

		<div class="grid grow min-w-[50vw]">
			<label for="purchase_link">Purchase link:</label>
			<input
				type="url"
				name="purchase_link"
				id="purchase_link"
				bind:value={gameSet.purchaseLink}
				placeholder="Link for QR display"
				title="Link for QR display"
			/>
		</div>
	</div>

	<div class="flex flex-wrap">
		<div class="grid content-start grow sm:grow-0">
			<label for="start_title">Start title:</label>
			<input
				type="text"
				name="start_title"
				id="start_title"
				bind:value={gameSet.start.title}
				placeholder="Name of starting location"
				title="Name of starting location"
			/>
		</div>

		<div class="grid grow min-w-[50vw]">
			<label for="start_link">Start link:</label>
			<input
				type="url"
				name="start_link"
				id="start_link"
				bind:value={gameSet.start.link}
				placeholder="Link to starting location"
				title="Link to starting location"
			/>
			<p class="place-self-end">
				<small
					><a
						href="https://wildblue.digital/resources/map-link-generator/"
						target="_blank">Universal Map Link Generator</a
					></small
				>
			</p>
		</div>
	</div>

	<div class="grid flex-wrap sm:flex">
		<button on:click={() => (setup = "base")} class="outline grow">
			<i class="fa-solid fa-circle-left" data-position="left" />Back</button
		>

		<button
			on:click={saveGameSet}
			class="order-first secondary grow sm:order-none"
		>
			<i class="fa-solid fa-floppy-disk" data-position="left" />Save Game Set</button
		>
	</div>
{:else if setup == "riddle"}
	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="riddle_gid">GID:</label>
			<input
				type="text"
				name="riddle_gid"
				maxlength="10"
				id="riddle_gid"
				bind:value={riddleSet.gid}
				placeholder="Game ID"
				title="Game ID"
			/>
		</div>
		<div class="grid grow">
			<label for="riddle_rid">RID:</label>
			<input
				type="text"
				name="riddle_rid"
				id="riddle_rid"
				bind:value={riddleSet.rid}
				placeholder="Riddle ID"
				title="Riddle ID"
			/>
			<small>aijacaqatierezipoca</small>
		</div>

		<div class="grid grow">
			<label for="rd_address">Next Riddle Address:</label>
			<input
				type="text"
				name="rd_address"
				id="rd_address"
				bind:value={riddleSet.rd_content.address}
				placeholder="Next riddle ID"
				title="The ID of the next riddle"
			/>
		</div>
	</div>

	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="riddle_header">Header:</label>
			<input
				type="text"
				name="riddle_header"
				id="riddle_header"
				bind:value={riddleSet.header}
				placeholder="default or custom"
			/>
		</div>
		<div class="grid grow">
			<label for="riddle_aside">Aside:</label>
			<input
				type="text"
				name="riddle_aside"
				id="riddle_aside"
				bind:value={riddleSet.aside}
				placeholder="default or custom"
			/>
		</div>
		<div class="grid grow">
			<label for="riddle_footer">Footer:</label>
			<input
				type="text"
				name="riddle_footer"
				id="riddle_footer"
				bind:value={riddleSet.footer}
				placeholder="default or custom"
			/>
		</div>
	</div>

	<div class="grid">
		<label for="riddle_main">Main:</label>
		<input
			type="text"
			name="riddle_main"
			id="riddle_main"
			bind:value={riddleSet.main}
			placeholder="html here for Main"
		/>
	</div>

	<div class="grid">
		<label for="riddle_customStyling">Custom styling:</label>
		<input
			type="text"
			name="riddle_customStyling"
			id="riddle_customStyling"
			bind:value={riddleSet.customStyling}
			placeholder="Custom css for this riddle screen"
			title="Custom css for this riddle screen"
		/>
	</div>

	<div class="flex flex-wrap">
		<div class="grid grow">
			<p>Riddle type:</p>
			<select bind:value={riddleSet.rd_content.type}>
				{#each types.names as type, i}
					<option value={types.values[i]}>{type}</option>
				{/each}
			</select>
		</div>

		{#if riddleSet.rd_content.type == "dnd-reorder" || riddleSet.rd_content.type == "dnd-reorder-show-input"}
			<div class="grid grow">
				<p>Order type:</p>
				<select bind:value={riddleSet.rd_content.order_type}>
					<option selected disabled value="disabled">Order type</option>
					<option value="horizontal">Horizontal</option>
					<option value="vertical">Vertical</option>
					<option value="grid">Grid</option>
				</select>
			</div>
		{:else if riddleSet.rd_content.type == "btn-order" || riddleSet.rd_content.type == "btn-order-hidden" || riddleSet.rd_content.type == "btn-to-input"}
			<div class="grid grow">
				<p>Order type:</p>
				<select bind:value={riddleSet.rd_content.panel_type}>
					<option selected disabled value="disabled">Panel type</option>
					<option value="horizontal">Horizontal</option>
					<option value="vertical">Vertical</option>
					<option value="grid">Grid</option>
				</select>
			</div>
		{/if}
	</div>

	{#if riddleSet.rd_content.type == "dnd-reorder" || riddleSet.rd_content.type == "dnd-reorder-show-input"}
		{#if riddleSet.rd_content.order_type == "grid"}
			<div class="flex flex-wrap">
				<div class="grid grow">
					<label for="order-rows">ROWS:</label>
					<input
						type="number"
						name="order-rows"
						id="order-rows"
						min="1"
						bind:value={riddleSet.rd_content.order_size.rows}
					/>
				</div>
				<div class="grid grow">
					<label for="order-cols">COLS:</label>
					<input
						type="number"
						name="order-cols"
						id="order-cols"
						min="1"
						bind:value={riddleSet.rd_content.order_size.cols}
					/>
				</div>
			</div>
		{/if}

		<div class="grid">
			{#each riddleSet.rd_content.order_id_list as order_id, i}
				<div class="flex flex-wrap">
					<div class="grid w-min grow">
						<label for={"rd_order_id_" + i}>ID {i + 1}:</label>

						<input
							type="text"
							name={"rd_order_id_" + i}
							id={"rd_order_id_" + i}
							bind:value={riddleSet.rd_content.order_id_list[i]}
						/>
					</div>

					<div class="grid grow">
						<label for={"rd_order_" + i}>Content {i + 1}:</label>
						<div class="flex">
							<input
								type="text"
								name={"rd_order_" + i}
								id={"rd_order_" + i}
								bind:value={riddleSet.rd_content.order_list[i]}
							/>
							<button
								on:click={() => (
									(rem = riddleSet.rd_content.order_id_list.splice(i, 1)),
									(riddleSet.rd_content.order_id_list =
										riddleSet.rd_content.order_id_list),
									(rem = riddleSet.rd_content.order_list.splice(i, 1)),
									(riddleSet.rd_content.order_list =
										riddleSet.rd_content.order_list)
								)}
								class="secondary"><i class="fa-solid fa-minus" /></button
							>
						</div>
					</div>
				</div>
			{/each}
		</div>
		<button
			on:click={() => (
				riddleSet.rd_content.order_list.length++,
				riddleSet.rd_content.order_id_list.length++
			)}><i class="fa-solid fa-plus" data-position="left" />New item</button
		>
	{/if}
	{#if riddleSet.rd_content.type == "btn-order" || riddleSet.rd_content.type == "btn-order-hidden" || riddleSet.rd_content.type == "btn-to-input"}
		{#if riddleSet.rd_content.panel_type == "grid"}
			<div class="flex flex-wrap">
				<div class="grid grow">
					<label for="panel-rows">ROWS:</label>
					<input
						type="number"
						name="panel-rows"
						id="panel-rows"
						min="1"
						bind:value={riddleSet.rd_content.panel_size.rows}
					/>
				</div>
				<div class="grid grow">
					<label for="panel-cols">COLS:</label>
					<input
						type="number"
						name="panel-cols"
						id="panel-cols"
						min="1"
						bind:value={riddleSet.rd_content.panel_size.cols}
					/>
				</div>
			</div>
		{/if}

		<div class="grid">
			{#each riddleSet.rd_content.panel_id_list as panel_id, i}
				<div class="flex flex-wrap">
					<div class="grid w-min grow">
						<label for={"rd_panel_id_" + i}>ID {i + 1}:</label>
						<input
							type="text"
							name={"rd_panel_id_" + i}
							id={"rd_panel_id_" + i}
							bind:value={riddleSet.rd_content.panel_id_list[i]}
						/>
					</div>

					<div class="grid grow">
						<label for={"rd_panel_" + i}>Content {i + 1}:</label>
						<div class="flex">
							<input
								type="text"
								name={"rd_panel_" + i}
								id={"rd_panel_" + i}
								bind:value={riddleSet.rd_content.panel_list[i]}
								class=" grow"
							/>
							<button
								on:click={() => (
									(rem = riddleSet.rd_content.panel_id_list.splice(i, 1)),
									(riddleSet.rd_content.panel_id_list =
										riddleSet.rd_content.panel_id_list),
									(rem = riddleSet.rd_content.panel_list.splice(i, 1)),
									(riddleSet.rd_content.panel_list =
										riddleSet.rd_content.panel_list)
								)}
								class="secondary"><i class="fa-solid fa-minus" /></button
							>
						</div>
					</div>
				</div>
			{/each}
			<p><small>REMINDER: Add thumbnails in the console.</small></p>
		</div>
		<button
			on:click={() => (
				riddleSet.rd_content.panel_list.length++,
				riddleSet.rd_content.panel_id_list.length++
			)}><i class="fa-solid fa-plus" data-position="left" />New item</button
		>
	{/if}

	<div class="grid">
		<p>Answers</p>

		{#if riddleSet.rd_content.type == "mc-multiple"}
			<p><small>&#123;"key":"value"&#125;</small></p>
			{#each complexAnswerTemp as answer, i}
				<!-- <label for={'rd_answers_' + i}>Answer {i + 1}:</label> -->
				<div class="flex">
					<input
						type="text"
						name={"rd_answers_" + i}
						id={"rd_answers_" + i}
						bind:value={complexAnswerTemp[i]}
						class=" grow"
						placeholder={"- answer " + (i + 1) + " -"}
						on:change={() => {
							if (
								complexAnswerTemp[i].includes("{") &&
								complexAnswerTemp[i].includes("}")
							) {
								riddleSet.rd_content.answers[i] = JSON.parse(
									complexAnswerTemp[i],
								);
								console.log(riddleSet.rd_content.answers[i]);
							} else {
								console.log("Incorrect format! This is not an object");
								riddleSet.rd_content.answers[i] = complexAnswerTemp[i];
							}
						}}
					/>
					<button
						on:click={() => (
							(rem = complexAnswerTemp.splice(i, 1)),
							(complexAnswerTemp = complexAnswerTemp)
						)}
						class="secondary"><i class="fa-solid fa-minus" /></button
					>
				</div>
			{/each}

			<button on:click={() => complexAnswerTemp.length++}>
				<i class="fa-solid fa-plus" data-position="left" />New answer</button
			>
		{:else}
			{#each riddleSet.rd_content.answers as answer, i}
				<!-- <label for={'rd_answers_' + i}>Answer {i + 1}:</label> -->
				<div class="flex">
					<input
						type="text"
						name={"rd_answers_" + i}
						id={"rd_answers_" + i}
						bind:value={riddleSet.rd_content.answers[i]}
						class=" grow"
						placeholder={"- answer " + (i + 1) + " -"}
					/>
					<button
						on:click={() => (
							(rem = riddleSet.rd_content.answers.splice(i, 1)),
							(riddleSet.rd_content.answers = riddleSet.rd_content.answers)
						)}
						class="secondary"><i class="fa-solid fa-minus" /></button
					>
				</div>
			{/each}
			<button on:click={() => riddleSet.rd_content.answers.length++}>
				<i class="fa-solid fa-plus" data-position="left" />New answer</button
			>
		{/if}
	</div>

	<div class="grid">
		<p>Hints</p>
		{#if riddleSet.rd_content.hints}
			{#each riddleSet.rd_content.hints as hint, i}
				<div class="flex flex-wrap">
					<input
						type="text"
						name={"rd_hints_guide_" + i}
						id={"rd_hints_guide_" + i}
						placeholder="Guide"
						title="Guide"
						bind:value={riddleSet.rd_content.hints[i].guide}
						class=" grow"
					/>
					<input
						type="text"
						name={"rd_hints_content_" + i}
						id={"rd_hints_content_" + i}
						placeholder="Content"
						title="Content"
						bind:value={riddleSet.rd_content.hints[i].content}
						class=" grow"
					/>
					<input
						type="number"
						min="0"
						name={"rd_hints_time_" + i}
						id={"rd_hints_time_" + i}
						placeholder="Penalty"
						title="Penalty"
						bind:value={riddleSet.rd_content.hints[i].time}
						class=" grow"
					/>
					<!-- confirm('Are you sure you want to remove this hint?')? -->
					<button
						on:click={() => (
							(rem = riddleSet.rd_content.hints.splice(i, 1)),
							(riddleSet.rd_content.hints = riddleSet.rd_content.hints)
						)}
						class="secondary"><i class="fa-solid fa-minus" /></button
					>
				</div>
			{/each}
		{/if}
		<button
			on:click={() => (
				riddleSet.rd_content.hints.push({ guide: "", content: "", time: 0 }),
				(riddleSet.rd_content.hints = riddleSet.rd_content.hints)
			)}><i class="fa-solid fa-plus" data-position="left" />New hint</button
		>
	</div>
	<div class="flex">
		<input
			type="checkbox"
			name="rd_isBonus"
			id="rd_isBonus"
			bind:checked={riddleSet.rd_content.isBonus}
		/><label for="rd_isBonus">This is a skippable bonus riddle?</label>
	</div>

	<div class="grid flex-wrap sm:flex">
		<button on:click={() => (setup = "base")} class="outline grow">
			<i class="fa-solid fa-circle-left" data-position="left" />Back</button
		>

		<button
			on:click={saveRiddleSet}
			class="order-first secondary grow sm:order-none"
		>
			<i class="fa-solid fa-floppy-disk" data-position="left" />Save Riddle Set</button
		>
	</div>

	<!-- <button on:click={saveRiddleSet}>SAVE riddle set</button> -->
	<!-- <button class="secondary" on:click={() => console.log(riddleSet)}>Print</button> -->

	<!-- <button on:click={() => (setup = 'base')}>Back</button> -->
{:else if setup == "open-game"}
	<label for="open-gid">GID:</label>
	<input
		type="text"
		name="open-gid"
		maxlength="10"
		id="open-gid"
		bind:value={openSet.gid}
		placeholder="Open Game ID"
		title="Game ID of the game you want to open"
	/>
	<button on:click={handleOpenGame}
		><i class="fa-solid fa-folder-open" data-position="left" />Open Game</button
	>
	<button on:click={() => (setup = "base")}
		><i class="fa-solid fa-circle-left" data-position="left" />Back</button
	>
{:else if setup == "open-riddle"}
	<label for="open-gid">GID:</label>
	<input
		type="text"
		name="open-gid"
		maxlength="10"
		id="open-gid"
		bind:value={openSet.gid}
		placeholder="Open Game ID"
		title="Game ID of the game you want to open"
	/>
	<label for="open-gid">RID:</label>
	<input
		type="text"
		name="open-rid"
		id="open-rid"
		bind:value={openSet.rid}
		placeholder="Open Riddle ID"
		title="Riddle ID of the riddle you want to open"
	/>
	<button on:click={handleOpenRiddle}
		><i class="fa-solid fa-folder-open" data-position="left" />Open Riddle</button
	>
	<button on:click={() => (setup = "base")}
		><i class="fa-solid fa-circle-left" data-position="left" />Back</button
	>
{/if}

<div class="grid gap-4" />

<style>
	:global(.obelisk select) {
		box-sizing: border-box;

		place-content: center;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity));
	}
	:global(.obelisk select) {
		margin: 10px;
		padding: 15px;
		border-radius: 0px;
		box-shadow: #093a86 5px 5px 0;
		color: #05204a;
	}
</style>
